export const __TEXT = {
  CONSENT: 'Zgoda',
  DETAILS: 'Szczegóły',
  ABOUT: 'O cookies'
}